// extracted by mini-css-extract-plugin
export default {"Box":"base-cell-module__Box--bqkLG","editingCell":"base-cell-module__editingCell--jdRFI","disallowSelection":"base-cell-module__disallowSelection--YmbjN"};